var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "jade-pagination", attrs: { "aria-label": "pagination" } },
    [
      _c("jade-icon-button", {
        attrs: {
          size: "medium",
          icon: "chevron-left",
          variant: "neutral-subtle",
          disabled: _vm.disabledPrevious,
          "data-testid": "button-previous",
        },
        on: {
          click: function ($event) {
            return _vm.$emit("onPrevious")
          },
        },
      }),
      _vm._t("default"),
      _c("jade-icon-button", {
        attrs: {
          size: "medium",
          icon: "chevron-right",
          variant: "neutral-subtle",
          disabled: _vm.disabledNext,
          "data-testid": "button-next",
        },
        on: {
          click: function ($event) {
            return _vm.$emit("onNext")
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }